export default {
  SET_INFO_SNACKBAR(state, {text, timeout}){
    state.infoSnackbar.visible = true
    state.infoSnackbar.text = text
    state.infoSnackbar.timeout = timeout
  },

  SET_INFO_SNACKBAR_LINK(state, link){
    state.infoSnackbar.hasAction = true
    state.infoSnackbar.link = link
  },

  SET_LOADING_SNACKBAR(state, {text}){
    state.loadingSnackbar.visible = true
    state.loadingSnackbar.text = text
    //state.loadingSnackbar.uploadPercentage = 0
  },

  SET_REPORT_SNACKBAR(state, { errorData, timeout}){
    state.reportSnackbar.visible = true
    state.reportSnackbar.errorData = errorData
    state.reportSnackbar.timeout = timeout
  },


  UPDATE_LOADING_PERCENTAGE(state, percentage){
    state.loadingSnackbar.uploadPercentage = percentage
  },

  CLOSE_SNACKBAR(state, type){
    switch(type) {
      case 'loading':
        state.loadingSnackbar.visible = false
        state.loadingSnackbar.text = ''
        //state.loadingSnackbar.uploadPercentage = 0
        break

      case 'info':
        state.infoSnackbar.visible = false
        state.infoSnackbar.text = ''
        state.infoSnackbar.timeout = null
        state.infoSnackbar.hasAction = false
        state.infoSnackbar.link = ''
        break

      case 'report':
        state.reportSnackbar.visible = false
        state.reportSnackbar.errorData = {}
        state.reportSnackbar.timeout = null
        break

      default:
        break
    }
  }
}
